import { Component } from '@angular/core';
@Component({
    selector: 'osc-utils-request-app-access',
    templateUrl: './request-app-access.component.html',
    styleUrls: ['./request-app-access.component.scss'],
    standalone: false
})
export class RequestAppAccessComponent {}
